import {BaseManager} from "../../../infrastructure/managers/base-manager";
import {singleton} from "../../../infrastructure/decorators/singleton";

@singleton
export class AdManager extends BaseManager {
  provider = null;
  adUnits: String = [];

  static injectables = [...BaseManager.injectables];

  initializeUnit(adUnit) {
  }

  refreshUnits(adUnits) {
  }

  refreshAll() {
  }

  destroyUnits(adUnits) {
  }

  destroyAll() {
  }

  registerToProviderReady(unit, callback) {
    this.callbacks.push({id: unit, callback});
  }
}
